/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Connection Room service
 */

namespace Application.Services {
    'use strict';

    import VideoFeed = Models.VideoFeed;
    import IVideoFeed = Models.IVideoFeed;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;

    /**
     * ConnectionRoomService
     */
    export class VideoFeedService {
        public static $name: string = "videoFeedService";
        public static $inject: string[] = ['$http', '$q', 'blockService', '$timeout', '$interval', 'backendService'];

        private http: ng.IHttpService;
        private qService: ng.IQService;
        private blockService: BlockService;
        private $timeout: ng.ITimeoutService;
        private $interval: ng.IIntervalService;
        private backendService: BackendService;

        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'flexocore/';
        private servicePath: string = '';
        private videofeedBackendUrl: string = this.backendBaseUrl + this.servicePath + 'videofeed';
        private videoFeedBlockQueue: IdMap;
        private videoFeedStreamPipeQueue: IdMap;
        private oldVideoFeedBlockQueue: IdMap = {};
        private oldVideoFeedStreamPipeQueue: IdMap = {};

        constructor($http: ng.IHttpService,
                    $q: ng.IQService,
                    blockService: BlockService,
                    $timeout: ng.ITimeoutService,
                    $interval: ng.IIntervalService,
                    backendService: BackendService) {
            this.http = $http;
            this.qService = $q;
            this.blockService = blockService;
            this.$timeout = $timeout;
            this.$interval = $interval;
            this.backendService = backendService;
            this.videoFeedBlockQueue = {};
            this.videoFeedStreamPipeQueue = {};
            this.initVideoFeedInterval();
        }

        public getVideoFeedByBlockId(blockId: string): ng.IPromise<VideoFeed> {
            let id: number = Common.Utils.idFromHref(blockId);
            let request: VideoFeedRequest = this.getOrCreateNewVideoFeedRequest(id, this.videoFeedBlockQueue, this.oldVideoFeedBlockQueue);
            return request.deferred.promise;
        }

        public getVideoFeedByBlockIdNoList(blockId: string): ng.IPromise<VideoFeed> {
            let id: number = Common.Utils.idFromHref(blockId);
            // Create a promise and push it to the map too
            let videoFeedRequest: VideoFeedRequest =
                new VideoFeedRequest(id, this.qService.defer());
            if (this.oldVideoFeedBlockQueue[id]) {
                // Only update the existing promises if we are using them...
                this.oldVideoFeedBlockQueue[id][0] = videoFeedRequest;
            }

            return this.http
                .get(this.videofeedBackendUrl + "/" + blockId)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<VideoFeed>>) => {
                    let halElement: IHalElement<VideoFeed> = data.data;
                    let converted: VideoFeed = HalConverter.convertElement(halElement, VideoFeed.Empty);
                    converted.thumbnailUrl = VideoFeed.setThumbnailPerStatus(converted);
                    videoFeedRequest.deferred.resolve(converted);
                    return converted;
                });
        }

        public getVideoFeedByStreamPipeId(streamPipeId: string): ng.IPromise<VideoFeed> {
            let id: number = Common.Utils.idFromHref(streamPipeId);
            let request: VideoFeedRequest = this.getOrCreateNewVideoFeedRequest(id, this.videoFeedStreamPipeQueue, 
                                                                                this.oldVideoFeedStreamPipeQueue);
            return request.deferred.promise;
        }
        
        public getVideoFeedByStreamPipeIdNoList(streamPipeId: string): ng.IPromise<VideoFeed> {
            return this.http
                .get(this.videofeedBackendUrl + "/streamPipe/" + streamPipeId)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<VideoFeed>>) => {
                    let halElement: IHalElement<VideoFeed> = data.data;
                    let converted: VideoFeed = HalConverter.convertElement(halElement, VideoFeed.Empty);
                    converted.thumbnailUrl = VideoFeed.setThumbnailPerStatus(converted);
                    return converted;
                });
        }

        public notifyVideoPlayAttemptByBlockId(blockId: string, videoFeed: IVideoFeed): ng.IPromise<void> {
            return this.http
                .post(this.videofeedBackendUrl + "/videoPlayAttemptByBlock/" + blockId, videoFeed)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<void>>) => {
                    return;
                });
        }

        public notifyVideoPlayAttemptByStreamPipeId(streamPipeId: number, videoFeed: IVideoFeed): ng.IPromise<void> {
            return this.http
                .post(this.videofeedBackendUrl + "/videoPlayAttemptByStreamPipe/" + streamPipeId, videoFeed)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<void>>) => {
                    return;
                });
        }

        public notifyVideoPlayErrorByBlockId(blockId: string,  videoFeed: IVideoFeed): ng.IPromise<void> {
            return this.http
                .post(this.videofeedBackendUrl + "/videoPlayErrorByBlock/" + blockId, videoFeed)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<void>>) => {
                    return;
                });
        }

        public notifyVideoPlayErrorByStreamPipeId(streamPipeId: number, videoFeed: IVideoFeed): ng.IPromise<void> {
            return this.http
                .post(this.videofeedBackendUrl + "/videoPlayErrorByStreamPipe/" + streamPipeId, videoFeed)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<void>>) => {
                    return;
                });
        }

        private getOrCreateNewVideoFeedRequest(id: number, idMap: IdMap, oldIdMap: IdMap): VideoFeedRequest {
            if (idMap[id] === undefined) {                
                idMap[id] = [];
            }
            let requests: VideoFeedRequest[] = idMap[id];
            let videoFeedRequest: VideoFeedRequest = 
                    new VideoFeedRequest(id, this.qService.defer());
            requests.push(videoFeedRequest);
            return oldIdMap[id] === undefined ? videoFeedRequest : oldIdMap[id][0];
        }
        
        private initVideoFeedInterval(): void {
            this.doMakeRequests();
            this.$interval(() => {
                this.doMakeRequests();
            }, 3000);
        }
        
        private doMakeRequests(): void {
            if (this.videoFeedBlockQueue && Object.keys(this.videoFeedBlockQueue).length > 0) {
                this.oldVideoFeedBlockQueue = this.videoFeedBlockQueue;
                this.videoFeedBlockQueue = {};
                this.getVideoFeedListPromise(this.oldVideoFeedBlockQueue, this.videofeedBackendUrl + "/list/byBlock");
            }

            if (this.videoFeedStreamPipeQueue && Object.keys(this.videoFeedStreamPipeQueue).length > 0) {
                this.oldVideoFeedStreamPipeQueue = this.videoFeedStreamPipeQueue;
                this.videoFeedStreamPipeQueue = {};
                this.getVideoFeedListPromise(this.oldVideoFeedStreamPipeQueue, this.videofeedBackendUrl + "/list/byStreamPipe");
            }
        }
        
        private getVideoFeedListPromise(requestMap: IdMap, url: string): void {
            let ids: number[] = Object.keys(requestMap).map((value: string) => {
                return parseInt(value, 10);
            });
            let requests: VideoFeedRequest[][] = ids.map((id: number) => {
                return requestMap[id];
            });
            this.http.post(url, {"ids": ids})
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<VideoFeed>[]>) => {
                    console.log("thumbnail result from backend", result);
                    let videoFeeds: Models.IHalElement<VideoFeed>[] = result.data;
                    videoFeeds.forEach((halElement: Models.IHalElement<VideoFeed>, index: number) => {
                        let videoFeed: VideoFeed = HalConverter.convertElement(halElement, VideoFeed.Empty);
                        videoFeed.thumbnailUrl = VideoFeed.setThumbnailPerStatus(videoFeed);
                        let requestsForIndex: VideoFeedRequest[] = requests[index];
                        requestsForIndex.forEach((request: VideoFeedRequest) => {
                            request.deferred.resolve(videoFeed);
                        });
                    });
                });
        }
    }
    
    /*
     * We need to store every request even though is for the same id because
     * different UI componentes could be waiting from the same id and we need
     * to notify each one when the promise is resolved
     */
    interface IdMap {
        [key: number]: VideoFeedRequest[]; 
    }
    
    class VideoFeedRequest {
        
        constructor(public id: number,
                    public deferred: ng.IDeferred<VideoFeed>) {
        }
        
    } 

}
